// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-panel[data-v-7f2a7225]{background-color:#f7f7f7;display:none;left:0;padding-top:80px;position:fixed;right:0;top:0;transition:max-height .4s ease-in-out}.nav-item-container:hover .nav-panel[data-v-7f2a7225]{display:block}@media screen and (max-width:968px){.bambee-logo[data-v-7f2a7225] svg{height:35px;width:120px}}@media screen and (max-width:320px){.bambee-logo[data-v-7f2a7225] svg{height:20px;width:90px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
